export default __webpack_public_path__ + "3caa2f59f78919fcc0f6e635673c72eb.png";